import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M5110 7155 c0 -24 2 -25 68 -25 148 0 408 -47 580 -106 95 -32 335
-149 422 -205 435 -281 757 -722 876 -1196 22 -92 31 -113 46 -113 24 0 23 12
-7 131 -125 493 -432 919 -873 1212 -294 195 -707 326 -1029 327 -82 0 -83 0
-83 -25z"/>
<path d="M5330 6126 c0 -2 7 -9 15 -16 13 -11 14 -10 9 4 -5 14 -24 23 -24 12z"/>
<path d="M5651 6114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4627 6030 c-11 -87 -9 -117 9 -124 9 -3 67 -6 130 -5 l115 1 140
-141 c77 -78 144 -141 148 -141 18 0 42 27 35 40 -3 8 -56 61 -117 118 -81 75
-113 99 -120 90 -6 -10 -7 -9 -4 3 3 10 -10 31 -36 57 -39 37 -47 41 -102 43
-33 1 -66 6 -72 12 -7 5 -13 27 -13 48 0 21 -4 41 -10 44 -5 3 -10 0 -10 -8 0
-42 -76 -45 -82 -4 -2 12 -7 -3 -11 -33z m278 -108 c-3 -3 -11 0 -18 7 -9 10
-8 11 6 5 10 -3 15 -9 12 -12z"/>
<path d="M4875 6060 c-13 -6 -15 -9 -5 -9 13 -1 13 -2 0 -11 -9 -6 -10 -10 -3
-10 7 0 17 9 23 20 6 11 9 20 8 19 -2 0 -12 -4 -23 -9z"/>
<path d="M4932 6050 c7 -11 17 -20 22 -20 5 0 1 9 -9 20 -10 11 -20 20 -22 20
-2 0 2 -9 9 -20z"/>
<path d="M5656 6048 c-4 -16 -12 -25 -17 -22 -5 3 -10 -7 -11 -23 -1 -19 -3
-14 -8 17 l-7 45 -2 -40 c-2 -31 -4 -35 -10 -20 -7 17 -17 20 -82 20 -60 1
-77 -3 -87 -17 -16 -21 -32 -15 -32 12 0 10 -4 21 -8 24 -5 3 -6 -22 -4 -54 4
-48 0 -65 -18 -95 -29 -47 -85 -75 -150 -75 -49 0 -53 2 -122 70 -71 69 -86
82 -72 58 5 -7 -8 1 -28 17 -20 17 -37 37 -37 45 -1 12 -3 13 -10 1 -7 -11 -9
-11 -13 0 -3 8 -8 12 -11 9 -4 -3 70 -82 163 -175 l170 -169 27 25 c71 64 225
155 309 183 48 15 53 20 63 59 7 24 11 63 9 87 -3 41 -4 43 -12 18z m-4 -75
c-3 -16 -7 -22 -10 -15 -4 13 4 42 11 42 2 0 2 -12 -1 -27z m-35 -25 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M4800 6040 c8 -5 24 -9 35 -9 l20 0 -20 9 c-11 5 -27 9 -35 9 -13 1
-13 0 0 -9z"/>
<path d="M4900 6040 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5411 6014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4975 6000 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M5005 5970 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4450 5907 c0 -2 6 -10 14 -16 11 -9 16 -9 22 1 4 7 4 10 -1 6 -4 -4
-14 -3 -22 3 -7 6 -13 9 -13 6z"/>
<path d="M4487 5874 c-3 -4 0 -13 8 -21 11 -10 19 -11 32 -4 16 9 16 10 -5 11
-13 0 -20 4 -17 10 7 11 -8 14 -18 4z"/>
<path d="M4584 5839 c-3 -6 -19 -9 -35 -7 -16 3 -29 0 -29 -5 0 -5 20 -7 45
-5 25 3 48 2 51 -3 3 -5 51 -9 107 -9 l102 -1 125 -124 c68 -69 132 -125 140
-125 9 0 22 6 29 13 10 10 -16 38 -126 144 l-138 132 -132 1 c-85 0 -134 -4
-139 -11z"/>
<path d="M4222 5831 c-10 -6 -1 -21 36 -60 l49 -51 224 0 224 -1 115 -114 c63
-63 120 -115 125 -115 6 0 20 7 31 14 18 14 13 21 -101 135 l-120 121 -250 0
-251 0 -29 30 c-15 16 -33 26 -38 23 -6 -4 -8 0 -4 10 7 19 7 20 -11 8z"/>
<path d="M5915 5833 c-174 -37 -293 -111 -533 -331 -270 -249 -444 -350 -664
-388 -137 -24 -275 -5 -377 52 -24 13 -46 24 -49 24 -16 0 82 -87 146 -130
203 -137 489 -132 722 11 28 17 48 35 45 40 -4 5 0 6 8 4 7 -3 22 3 32 15 20
22 8 28 -14 8 -11 -11 -13 -10 -8 5 4 9 2 17 -3 17 -6 0 -10 -4 -10 -10 0 -5
-22 -1 -48 9 -32 13 -54 16 -63 10 -8 -5 -18 -9 -23 -9 -5 0 17 17 50 38 63
41 200 159 324 278 41 39 89 84 107 98 28 24 32 25 36 9 4 -15 5 -15 6 2 1 25
37 51 44 32 3 -9 8 -9 20 2 12 9 17 10 17 2 0 -6 -7 -14 -16 -18 -13 -5 -13
-7 -2 -14 10 -6 9 -11 -7 -23 -11 -8 -17 -17 -14 -21 4 -3 25 11 49 32 145
131 348 195 530 167 66 -10 78 -9 104 7 l28 17 -33 18 c-67 36 -159 54 -274
53 -60 -1 -119 -3 -130 -6z m-125 -167 c-7 -7 -13 -7 -20 0 -6 6 -3 10 10 10
13 0 16 -4 10 -10z m-45 -16 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4
10 3 0 8 -4 11 -10z m-47 -56 c-11 -11 -18 -12 -22 -5 -4 6 0 11 8 11 10 0 13
6 9 18 -5 14 -3 15 8 4 11 -10 11 -15 -3 -28z"/>
<path d="M6005 5691 c-68 -19 -146 -57 -208 -100 -40 -28 -75 -62 -328 -325
-179 -186 -331 -288 -494 -332 -78 -21 -226 -29 -295 -16 -30 6 -58 8 -61 6
-4 -2 -4 -15 -1 -29 l4 -25 367 0 c215 0 384 5 411 11 226 52 362 251 330 480
-12 83 -15 77 99 187 70 68 202 142 252 142 l26 0 -18 -67 c-20 -73 -24 -95
-11 -78 4 6 45 42 91 80 78 65 83 70 60 76 -45 13 -164 8 -224 -10z"/>
<path d="M4026 5643 c-28 -28 -28 -52 2 -85 20 -24 68 -23 89 2 16 19 30 20
186 20 l169 0 20 25 c18 23 27 26 72 23 l51 -3 3 -148 3 -147 27 6 c100 23
150 38 200 62 51 24 57 31 60 61 3 31 -4 42 -85 123 l-88 88 -119 0 c-118 0
-121 0 -141 -27 l-22 -26 -158 1 c-125 0 -161 4 -170 15 -11 15 -48 37 -63 37
-5 0 -21 -12 -36 -27z m62 -12 c8 -4 12 -19 10 -32 -2 -18 -9 -24 -28 -24 -19
0 -26 6 -28 24 -3 20 11 41 28 41 3 0 11 -4 18 -9z"/>
<path d="M5560 5555 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M4985 5400 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4175 5378 c29 -42 110 -121 150 -146 72 -46 134 -63 245 -69 126 -7
227 15 358 77 83 40 157 88 147 98 -3 3 -13 -2 -22 -10 -24 -21 -63 -32 -63
-19 0 6 9 11 21 11 11 0 18 4 14 10 -4 6 -15 6 -31 0 -37 -15 -42 -12 -15 10
25 21 21 26 -9 10 -10 -5 -42 -12 -71 -14 -30 -3 -81 -14 -114 -26 -76 -26
-254 -37 -347 -21 -72 12 -192 58 -237 91 -38 26 -46 25 -26 -2z"/>
<path d="M4940 5374 l-25 -15 25 7 c28 7 35 12 29 18 -2 2 -15 -2 -29 -10z"/>
<path d="M5275 5170 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6065 4523 c-52 -9 -66 -15 -85 -35 -27 -29 -26 -79 3 -105 12 -11
48 -30 80 -43 40 -16 57 -28 57 -40 0 -30 -53 -35 -103 -11 -39 20 -43 20 -54
4 -20 -26 -16 -41 15 -57 83 -43 181 -25 207 38 25 60 -4 100 -93 127 -56 16
-73 36 -47 55 24 18 37 18 82 -1 20 -8 37 -14 38 -13 6 7 25 47 25 52 0 11
-96 33 -125 29z"/>
<path d="M3320 4370 l0 -150 94 0 c108 0 149 11 165 46 16 36 14 49 -15 83
-23 28 -24 32 -10 47 26 25 20 79 -10 103 -23 18 -41 21 -125 21 l-99 0 0
-150z m175 60 c0 -23 -4 -25 -52 -28 l-53 -3 0 31 0 31 53 -3 c48 -3 52 -5 52
-28z m13 -103 c12 -13 12 -17 -7 -36 -15 -15 -34 -21 -66 -21 -44 0 -45 0 -45
33 0 19 2 36 5 39 10 10 99 -1 113 -15z"/>
<path d="M3720 4488 c-7 -18 -26 -62 -43 -98 -16 -36 -35 -83 -43 -104 -8 -22
-19 -45 -25 -53 -9 -10 -4 -13 29 -13 35 0 41 4 52 30 12 29 14 30 80 30 66 0
68 -1 80 -30 10 -25 18 -30 46 -30 19 0 34 2 34 5 0 7 -34 92 -64 160 -64 144
-58 135 -97 135 -32 0 -38 -4 -49 -32z m74 -98 c9 -22 16 -43 16 -45 0 -3 -18
-5 -41 -5 -22 0 -39 3 -37 8 2 4 10 24 18 45 8 20 17 37 21 37 4 0 14 -18 23
-40z"/>
<path d="M3930 4513 c0 -4 21 -72 47 -150 48 -146 56 -158 102 -146 18 5 41
61 67 166 9 39 18 26 49 -75 l26 -88 39 0 39 0 25 83 c14 45 34 111 46 146 11
35 20 65 20 67 0 2 -15 4 -33 4 -34 0 -34 0 -61 -87 -14 -49 -26 -94 -26 -100
0 -7 -4 -13 -8 -13 -5 0 -21 44 -38 98 l-29 97 -34 0 c-38 0 -32 9 -76 -137
-9 -32 -20 -58 -24 -58 -3 0 -18 44 -31 98 l-25 97 -37 3 c-21 2 -38 0 -38 -5z"/>
<path d="M4503 4503 c-3 -10 -32 -76 -64 -148 -31 -71 -55 -133 -53 -136 2 -3
17 -4 34 -1 21 3 35 13 46 33 14 27 18 29 79 29 62 0 65 -1 80 -30 13 -25 22
-30 50 -30 23 0 33 4 30 13 -3 6 -31 73 -63 147 l-58 135 -37 3 c-29 2 -39 -1
-44 -15z m80 -166 c-4 -7 -63 0 -71 8 -2 2 4 25 14 51 l18 48 22 -50 c12 -27
20 -52 17 -57z"/>
<path d="M4747 4513 c-4 -3 -7 -71 -7 -151 l0 -144 103 4 c117 4 143 16 177
84 25 51 25 77 -1 130 -29 61 -80 84 -185 84 -45 0 -84 -3 -87 -7z m188 -78
c19 -18 25 -35 25 -69 0 -58 -32 -86 -99 -86 l-46 0 1 83 c1 45 2 85 3 90 0 4
21 7 46 7 35 0 52 -6 70 -25z"/>
<path d="M5165 4488 c-7 -18 -34 -80 -60 -138 -25 -58 -49 -111 -52 -117 -3
-9 6 -13 31 -13 29 0 38 5 51 30 15 29 18 30 81 30 63 0 65 -1 75 -30 9 -25
16 -30 45 -30 19 0 34 4 34 9 0 9 -46 123 -82 201 -11 24 -24 55 -29 67 -7 18
-16 23 -44 23 -31 0 -38 -4 -50 -32z m75 -104 c7 -19 10 -37 8 -39 -1 -2 -19
-5 -38 -6 -38 -4 -39 0 -15 58 17 40 29 37 45 -13z"/>
<path d="M5369 4518 c0 -2 -2 -15 -4 -30 -4 -27 -2 -28 46 -28 l49 0 0 -120 0
-120 35 0 35 0 0 120 0 120 45 0 c43 0 45 1 45 30 l0 30 -125 0 c-69 0 -125
-1 -126 -2z"/>
<path d="M5720 4496 c-5 -15 -18 -45 -29 -69 -40 -91 -64 -143 -77 -174 l-14
-33 38 0 c33 0 39 4 49 30 11 29 13 30 78 30 64 0 66 -1 76 -30 10 -26 16 -30
50 -30 21 0 39 1 39 3 0 1 -28 67 -63 147 l-62 145 -38 3 c-32 3 -38 0 -47
-22z m84 -158 c-5 -7 -63 -2 -72 7 -2 2 4 25 14 51 l18 48 22 -49 c13 -27 21
-52 18 -57z"/>
<path d="M6240 4420 c0 -128 13 -163 72 -190 52 -23 78 -25 123 -6 59 25 75
64 75 189 l0 107 -35 0 -35 0 0 -103 c0 -117 -10 -137 -68 -137 -50 0 -62 28
-62 142 l0 98 -35 0 -35 0 0 -100z"/>
<path d="M6580 4370 l0 -150 95 0 c100 0 147 13 159 45 12 32 6 69 -14 90 -20
21 -20 23 -4 52 15 26 16 34 4 62 -17 42 -43 51 -151 51 l-89 0 0 -150z m170
75 c21 -25 -5 -45 -59 -45 -47 0 -47 0 -43 30 4 28 7 30 47 30 26 0 47 -6 55
-15z m15 -134 c0 -20 -7 -27 -34 -33 -18 -5 -45 -8 -59 -6 -22 3 -27 8 -28 36
l-2 33 62 -3 c57 -3 61 -5 61 -27z"/>
<path d="M3470 3945 c-35 -42 281 -357 503 -501 92 -60 256 -144 348 -178 82
-31 83 -31 75 -10 -3 8 -2 12 4 9 6 -3 10 -2 10 4 0 5 -10 13 -22 16 -70 21
-309 148 -423 223 -133 89 -336 278 -425 395 -46 61 -51 65 -70 42z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
